import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding: 30px;\n  box-sizing: border-box;\n  width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: ", "px;\n  box-sizing: border-box;\n  width: 100%;\n  ", "\n\n  @media screen and (max-width: ", "px) {\n    padding: 30px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      min-height: ", "px;\n      display: flex;\n      flex-direction: column;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      border-radius: ", ";\n      border: 1.5px solid ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (min-width: ", "px) {\n    border: 1.5px solid ", ";\n    border-radius: ", ";\n  }\n  width: 100%;\n  ", "\n\n  background: ", ";\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from '../utils/styling/styled-components';
var A4_Card = styled.div(_templateObject(), function (props) {
  return props.theme.breakpoints.sm + 1;
}, function (props) {
  return props.theme.colors.ivory;
}, function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.displayBorder && css(_templateObject2(), props.theme.borderRadius.large, props.theme.colors.ivory);
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return (
    /**
     * When using a minHeight on the Card, we want to allow the content area to grow.
     * Adding display: flex allows this.
     */
    props.minHeight && css(_templateObject3(), props.minHeight)
  );
});
var paddingMap = {
  large: 80,
  medium: 50,
  small: 30,
  none: 0
};
var A4_CardContent = styled.div(_templateObject4(), function (_ref) {
  var _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'small' : _ref$padding;
  return paddingMap[padding];
}, function (props) {
  return props.isContentCenterAligned && "\n    margin: auto; // Makes the content take up center aligned within available space and and pins footer to the bottom.\n  ";
}, function (props) {
  return props.theme.breakpoints.sm;
});
var A4_CardFooter = styled.div(_templateObject5());
export { A4_Card, A4_CardFooter, A4_CardContent };